import { ReactNode } from 'react';
import styles from './item.module.scss';
import classNames from 'classnames/bind';

const classesContext = classNames.bind(styles);

export default function ListingsDetailsItem({
  title,
  content,
  isLengthyDetails
}: {
  title: string;
  content: ReactNode;
  isLengthyDetails?: boolean;
}): JSX.Element {
  return (
    <div className={classesContext(styles.details, { details__lengthy: isLengthyDetails })}>
      <strong className={styles.details_title}>{title}:</strong>
      <div className={styles.details_content}>{content}</div>
    </div>
  );
}
